module.exports = __webpack_public_path__ + "static/media/rotonde.b4076c59.jpg";